import { ReactElement } from 'react';

import { DashboardVariantV2GiverStatusInfoWidgetCardProps } from './types';
import { DashboardVariantV2GiverStatusInfoWidgetCardBase } from './styles';
import DashboardVariantV2GiverStatusInfoWidgetCardHeader from '../StatusInfoWidgetCardHeader';
import { Stack } from '@mui/material';

const DashboardVariantV2GiverStatusInfoWidgetCard = ({
  accentColor = '#000000de',
  isSelected = false,
  onSelected,
  header,
  content,
  info,
}: DashboardVariantV2GiverStatusInfoWidgetCardProps): ReactElement => (
  <DashboardVariantV2GiverStatusInfoWidgetCardBase
    accentColor={accentColor}
    isSelected={isSelected}
    onClick={onSelected}
  >
    <Stack spacing={1} flex={1}>
      <DashboardVariantV2GiverStatusInfoWidgetCardHeader {...header} />

      {content}
    </Stack>

    {info}
  </DashboardVariantV2GiverStatusInfoWidgetCardBase>
);

export default DashboardVariantV2GiverStatusInfoWidgetCard;
